import React from 'react';
import Header from '../../components/layout/Header';
import NotificationList from '../../components/notifications/NotificationList';

export default function Notifications() {
  return (
    <div className="flex-1 flex flex-col min-h-0">
      <Header title="Notifications" breadcrumbs={[{ workspace: true }, { label: 'Notifications' }]} />
      <main className="flex-1 overflow-auto p-6 pb-20 md:pb-6">
        <NotificationList basePath="/dashboard" />
      </main>
    </div>
  );
}
